export default "__VITE_ASSET__DsL2VxED__"